import React from 'react';
import Hero from './components/omr-details/Hero';
import Main from './components/omr-details/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const OmrDetails = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default OmrDetails;